import { ApiService } from 'src/app/services/api.service'
import { ErrorResponse } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { BaseError, Http401Error, Http403Error, HttpError } from './errors'

export function handleArpioError(navigatedUrl: string, apiService: ApiService, uiService: UiService) {
  return (error: BaseError) => {
    if (error instanceof Http401Error && apiService) {
      let errorBody = error.body as ErrorResponse
      let authenticateUrl = apiService.buildUrl([errorBody.authenticateUrl])
      apiService.startAuthFlow(authenticateUrl, navigatedUrl).subscribe(
        (redirectUrl: string) => {
          // have to use window.location.href here because router.navigate() can't
          // transition outside of the Angular application.
          window.location.href = redirectUrl
        },
        (error: BaseError) => uiService.announceApiError(error)
      )
    } else if (error instanceof Http403Error) {
      // Redirect to the access denied page
      window.location.href = '/access-denied'
    } else {
      // Use announceApiError for better error handling and user-friendly messages
      uiService.announceApiError(error)
    }
  }
}

export function getErrorMessage(error: BaseError): string {
  if (error instanceof HttpError) {
    return (error.body as ErrorResponse).message
  } else {
    console.error(error)
    return error.message
  }
}
